// src/components/TestimonialsCarousel.jsx
//
// Shared testimonials carousel (Feature 7). Mirrors the marketing homepage's
// testimonials block structure so once Danielle enables + adds testimonials
// (siteText.testimonials) they can appear on any surface that reads the same
// content -- currently the logged-in dashboard. Gated identically to the
// homepage: renders NOTHING unless enabled AND at least one testimonial has a
// quote. `palette` supplies the per-surface colour-token class-names so each
// page keeps its own aesthetic without duplicating the markup.
import React from 'react';
import { imageUrl } from '../utils/imageUrl.js';
import { imageFrameStyle, imageFrameBox } from '../utils/imageFrame.js';

export default function TestimonialsCarousel({ enabled, testimonials, title, subtitle, palette }) {
    const items = (testimonials || []).filter((t) => t.quote);
    if (!enabled || items.length === 0) return null;
    const p = palette;
    return (
        <section id="testimonials-carousel" className={p.section}>
            <div className="max-w-6xl mx-auto px-4 md:px-8">
                <div className="text-center mb-12">
                    <div className={`ornamental-divider mb-6 ${p.accentText}`}>
                        <span className="font-display text-xs font-semibold text-book-muted">{title}</span>
                    </div>
                    <p className={`font-serif italic ${p.mutedText} text-lg`}>{subtitle}</p>
                </div>
                <div className="flex gap-5 overflow-x-auto pb-4 snap-x snap-mandatory" style={{ scrollbarWidth: 'thin' }}>
                    {items.map((t) => (
                        <div key={t.id} className={`flex-shrink-0 w-80 md:w-[28rem] snap-center border ${p.cardBorder} ${p.cardBg} p-6 decorative-corner ${p.accentText}`}>
                            <p className={`font-serif italic ${p.bodyText} text-base leading-relaxed mb-5`}>"{t.quote}"</p>
                            <div className={`flex items-center gap-3 pt-4 border-t ${p.hr}`}>
                                {t.photoUrl ? (
                                    <div className={`w-12 h-12 rounded-full overflow-hidden border ${p.avatarBorder} flex-shrink-0`}>
                                        <img src={imageUrl(t.photoUrl)} style={imageFrameStyle(t.photoUrlFrame)} alt={t.studentName} className="w-full h-full object-cover" />
                                    </div>
                                ) : (
                                    <div className={`w-12 h-12 rounded-full ${p.avatarBg} border ${p.avatarBorder} flex-shrink-0`} />
                                )}
                                <div>
                                    <div className={`font-display ${p.accentText} text-sm font-semibold`}>{t.studentName || 'Student'}</div>
                                    {t.studentContext && (
                                        <div className={`font-serif italic ${p.mutedText} text-xs mt-1`}>{t.studentContext}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
